<template>
  <v-bottom-sheet v-model="stShowIndex" hide-overlay>
      <v-sheet class="text-right">
        <v-btn 
          icon
          color="primary"
          class="btn-close"
          @click="showIndex"
        >
          <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
        </v-btn>        
        <Index @close-index="showIndex" />
      </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Index from './bookUtils/Index.vue';

export default {
  components: {
    Index,
  },
  methods: {
    ...mapActions('bookReading', [
      'showIndex',
    ]),
  },
  computed: {
    ...mapState({
      stShowIndex: (state) => state.bookReading.mobileTools.showIndex,
    })
  }
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}


</style>